/**
 * Theme Toggle
 * Switches between scroll (library) and paper themes (persisted in localStorage).
 */

import React, { useState } from 'react';
import { Feather, ScrollText } from 'lucide-react';
import { getTheme, toggleTheme } from '../../utils/theme';

const ICONS = { scroll: Feather, paper: ScrollText };
const NEXT = { scroll: 'paper', paper: 'scroll' };

const ThemeToggle = () => {
  const [theme, setTheme] = useState(getTheme());

  const handleToggle = () => setTheme(toggleTheme());

  const Icon = ICONS[theme] || Feather;

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={handleToggle}
      title={`Theme: ${theme} — switch to ${NEXT[theme]}`}
      aria-label="Switch theme"
    >
      <Icon size={18} />
    </button>
  );
};

export default ThemeToggle;
